document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.getElementById('navToggle');
  const overlay = document.getElementById('navOverlay');

  if (!toggle || !overlay) return;

  toggle.addEventListener('click', () => {
    toggle.classList.toggle('active');
    overlay.classList.toggle('active');
  });

  overlay.addEventListener('click', (e) => {
    const link = e.target.closest('a');

    if (!link) return;

    toggle.classList.remove('active');
    overlay.classList.remove('active');
  });
});
